import React, { Component } from 'react';
import { string, bool, func, shape, arrayOf } from 'prop-types';
import { Switch, Tooltip } from '@material-ui/core/index';
import { timeZoneType } from '../TimeZoneSelector/constants';
import { Help } from '@material-ui/icons';
import TimeZoneSelector from '../TimeZoneSelector';

import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import styles from './styles.scss';

const muiTheme = createTheme({
  overrides: {
    MuiSvgIcon: {
      root: {
        fontSize: '16px'
      }
    }
  }
});
export const TIME_ZONE = 'timezone';
export default class TimeZone extends Component {
  static propTypes = {
    title: string,
    description: string,
    timeZones: arrayOf(timeZoneType),
    popularTimeZones: arrayOf(timeZoneType),
    selectedTimeZone: shape({
      name: string,
      timezoneKey: string
    }),
    overrideDescription: string,
    isOverrideable: bool,
    timeZoneLabel: string,
    tooltipText: string,
    onChange: func
  };

  static defaultProps = {
    title: 'Time Zone',
    description: 'Set the default time zone for campaigns or allow users to override the default. Data will be calculated using the selected time zone.',
    overrideDescription: 'Allow users to override the admin setting and set the time zone.',
    tooltipText: 'Campaign data is presented in the selected time zone.',
    timeZoneLabel: 'Default time zone',
    timeZones: [],
    popularTimeZones: []
  };

  handleChange = (selectedTimeZone) => {
    const { onChange, isOverrideable } = this.props;
    const { name, timezoneKey } = selectedTimeZone;

    onChange && onChange({
      setting_name: TIME_ZONE,
      setting_value: {
        name,
        timezoneKey,
        isOverride: isOverrideable
      }
    });
  }

  handleOverrideChange = () => {
    const { onChange, selectedTimeZone, isOverrideable } = this.props;
    const { name, timezoneKey } = selectedTimeZone;

    onChange && onChange({
      setting_name: TIME_ZONE,
      setting_value: {
        name,
        timezoneKey,
        isOverride: !isOverrideable
      }
    });
  }

  render() {
    const {
      timeZones,
      popularTimeZones,
      selectedTimeZone,
      title,
      description,
      overrideDescription,
      isOverrideable,
      timeZoneLabel,
      tooltipText
    } = this.props;

    return (
      <div className={styles.timeZoneContainer}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.switchBox}>
          <Switch
            checked={isOverrideable}
            onChange={this.handleOverrideChange}
            name="isOverrideable"
            color="primary"
          />
          <span className={styles.switchDescription}>
            {overrideDescription}
          </span>
        </div>
        <div className={styles.timeZoneLabelContainer}>
          <MuiThemeProvider theme={muiTheme}>
            <div className={styles.labelContainer}>
              <span className={styles.timeZoneLabel}>{timeZoneLabel}</span>
              <Tooltip title={tooltipText} placement="right-end">
                <span>
                <Help
                  className={styles.icon}
                />
                </span>
              </Tooltip>
            </div>
            <div className={styles.timeZoneSelector}>
              <TimeZoneSelector
                timeZones={timeZones}
                popularTimeZones={popularTimeZones}
                selectedTimeZone={selectedTimeZone}
                onChange={this.handleChange}
              />
            </div>
          </MuiThemeProvider>
        </div>
      </div>
    );
  }
}
